import { generateDates } from 'core/common/utils/generateDates';

export const shortMonthsListEn = [
  'Jan',
  'Feb',
  'Mar',
  'Apr',
  'May',
  'Jun',
  'Jul',
  'Aug',
  'Sep',
  'Oct',
  'Nov',
  'Dec',
];

export const monthsListEn = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
];

export const DEFAULT_MIN_AGE = 18;

export const earliestBirthYear = 1940;

const greatestBirthYear = new Date().getFullYear() - DEFAULT_MIN_AGE;

export const yearsList = generateDates(earliestBirthYear, greatestBirthYear, 'increment');
